<template>
<div class="card">
    <div class="card-body help-card-body">
       <div class="text-center">
            <h4>Objective</h4>
        </div>
        <hr>
        <p>A r&egrave;sum&egrave; objective is a statement of your goals for employment. A r&egrave;sum&egrave; objective is typically one or two sentences long.</p>
        <div class='card mb-3'>
          <div class='card-body'>
            <h5 class="card-title"><i>Example #1</i></h5>
            "I am a friendly, highly driven, and motivated individual seeking an entry-level position in a fast-paced restaurant that allows for the application of costomer service and food preperation skills."
          </div>
        </div>
        <div class='card mb-3'>
          <div class='card-body'>
            <h5 class="card-title"><i>Example #2</i></h5>
            "I am a strong problem-solver and analytical thinker seeking an administrative position to improve the workflow and efficiencies in an office setting. I have excellent communication and organizational skills built on 3 years for administrative experience."
          </div>
        </div>
        <p>Make sure to not write down a to narrow objective, which could exclude you from other job positions</p>
        <p>Make sure you have a clear statement leaving no need for the employeer to ask for clarification. Because they won't.</p>
    </div>
</div>
</template>

<script>

export default {
  name: 'objective',
  components: {

  },
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style>

</style>
